// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../../component/table/table-layout';
import Swal from 'sweetalert2';

const AddInvoicePopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style, records }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });
    const [selectedIds, setSelectedIds] = useState([]);
    const [isTryToSubmit, setIsTryToSubmit] = useState(false);

    useEffect(() => {
        if (currentData?.id) {
            formik.setFieldValue("date", currentData?.date ? moment(currentData?.date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("gallon", currentData?.quantity ? currentData?.quantity?.replaceAll(",", "") : "")
            formik.setFieldValue("bill_amount", currentData?.amount ? currentData?.amount?.replaceAll("PKR ", "")?.replaceAll(",", "") : "")
            formik.setFieldValue("vendor_id", currentData?.vendor_id || "")
            formik.setFieldValue("bill_receipt_number", currentData?.bill_receipt_number || "")
            formik.setFieldValue("tanker_no", currentData?.tanker_no || "")
            formik.setFieldValue("notes", currentData?.notes || "")
            formik.setFieldValue("invoice_path", currentData?.bill_receipt_path || "");
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        month: yup.string().required('This Field is required'),
        bill_amount: yup.string().required('This Field is required'),
        vendor_id: yup.string().required('This Field is required'),
        invoice_no: yup.string().required('This Field is required'),
        invoice_path: yup.string().required('This Field is required')
    });

    const toggleIds = (id) => {
        let allSelected = [...selectedIds]
        if(allSelected.includes(id)){
            allSelected = allSelected.filter((eachId) => eachId != id)
        }else{
            allSelected.push(id)
        }
        setSelectedIds(allSelected);
    }

    const formik = useFormik({
        initialValues: {
            month: "",
            bill_amount: "",
            vendor_id: "",
            invoice_no: "",
            invoice_path: "",
            notes: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            setIsTryToSubmit(true);
            if(!selectedIds?.length) return;
            // console.log("Values", values);

            let totalAmount = 0;

            let allSelectedList = records.filter((eachRecord) => selectedIds.includes(eachRecord.id))

            for(let i=0; i < allSelectedList?.length; i++){
                totalAmount += Number(allSelectedList[i]?.amount?.replaceAll("PKR ", "")?.replaceAll(",", ""))
            }

            console.log(allSelectedList);
            console.log(totalAmount);

            if(Math.floor(totalAmount) != Math.floor(values.bill_amount)){
                Swal.fire('Error', 'Selected Amount and Enter Amount Not Same', 'error');
                return;
            }

            // console.log(allSelectedList);
            const apiData = JSON.stringify({
                "month": moment(values.month, "YYYY-MM").format("MM-YYYY"),
                "vendor_id": values.vendor_id,
                "invoice_no": values.invoice_no,
                "invoice_path": values.invoice_path,
                "total_amount": values.bill_amount,
                "notes": values.notes,
                "entry_ids": selectedIds,
                "tankers_count": selectedIds.length
            });

            try {
                const resp = await apiCall({ method: "post", url: `store-water-tanker-invoice`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Month</FormLabel>
                            <input
                                type={'month'}
                                name={'month'}
                                onChange={formik.handleChange}
                                value={formik.values.month}
                                max={moment(new Date()).format("YYYY-MM-DD")}
                            />
                            {formik.touched.month && formik.errors.month && (
                                <FeildError>{formik.errors.month}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Vendor</FormLabel>

                            <SelectSearch
                                name="vendor_id"
                                placeholder="- Select Vendor -"
                                onChange={(val) => {
                                    formik.setFieldValue("vendor_id", val);
                                }}
                                value={formik.values.vendor_id}
                                options={dropdowns?.vendor?.map((el) => ({
                                    label: el.full_name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.vendor_id && formik.errors.vendor_id && (
                                <FeildError>{formik.errors.vendor_id}</FeildError>
                            )}
                        </FeildWraper>

                        {/* <FeildWraper>
                            <FormLabel required>Building</FormLabel>

                            <SelectSearch
                                name="location_id"
                                placeholder="- Select Building -"
                                onChange={(val) => {
                                    formik.setFieldValue("location_id", val);
                                }}
                                value={formik.values.location_id}
                                options={dropdowns?.building?.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.location_id && formik.errors.location_id && (
                                <FeildError>{formik.errors.location_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Vendor</FormLabel>

                            <SelectSearch
                                name="vendor_id"
                                placeholder="- Select Vendor -"
                                onChange={(val) => {
                                    formik.setFieldValue("vendor_id", val);
                                }}
                                value={formik.values.vendor_id}
                                options={dropdowns?.vendor?.map((el) => ({
                                    label: el.full_name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.vendor_id && formik.errors.vendor_id && (
                                <FeildError>{formik.errors.vendor_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Number Of Gallon</FormLabel>
                            <input
                                type={'number'}
                                name={'gallon'}
                                onChange={formik.handleChange}
                                value={formik.values.gallon}
                                placeholder='Number Of Gallon'
                            />
                            {formik.touched.gallon && formik.errors.gallon && (
                                <FeildError>{formik.errors.gallon}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Tanker Number</FormLabel>
                            <input
                                type={'text'}
                                name={'tanker_no'}
                                onChange={formik.handleChange}
                                value={formik.values.tanker_no}
                                placeholder='Tanker Number'
                            />
                            {formik.touched.tanker_no && formik.errors.tanker_no && (
                                <FeildError>{formik.errors.tanker_no}</FeildError>
                            )}
                        </FeildWraper> */}

                        <FeildWraper>
                            <FormLabel required>Total Amount</FormLabel>
                            <input
                                type={'number'}
                                name={'bill_amount'}
                                onChange={formik.handleChange}
                                value={formik.values.bill_amount}
                                placeholder='Total Amount'
                            />
                            {formik.touched.bill_amount && formik.errors.bill_amount && (
                                <FeildError>{formik.errors.bill_amount}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Invoice Number</FormLabel>
                            <input
                                type={'text'}
                                name={'invoice_no'}
                                onChange={formik.handleChange}
                                value={formik.values.invoice_no}
                                placeholder='Invoice Number'
                            />
                            {formik.touched.invoice_no && formik.errors.invoice_no && (
                                <FeildError>{formik.errors.invoice_no}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel>Notes</FormLabel>

                            <textarea
                                type={'text'}
                                name={'notes'}
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                                placeholder='notes'
                            />
                            {formik.touched.notes && formik.errors.notes && (
                                <FeildError>{formik.errors.notes}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Invoice Receipt</FormLabel>

                            <FileUploadProgressBar
                                value={formik.values.invoice_path}
                                onChange={(file) => formik.setFieldValue("invoice_path", file)}
                                loader={formik.values.invoice_path}
                                // acceptType="pdf"
                            />
                            {
                                (formik.touched.invoice_path && Boolean(formik.errors.invoice_path)) && (
                                    <FeildError>{formik.touched.invoice_path && formik.errors.invoice_path}</FeildError>
                                )
                            }
                        </FeildWraper>
                    </FormArea>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell header>
                                    Date
                                </TableCell>

                                <TableCell header>
                                    Location
                                </TableCell>

                                <TableCell header>
                                    Tanker Number
                                </TableCell>

                                <TableCell header>
                                    Quantity (Gallon)
                                </TableCell>

                                <TableCell header>
                                    Amount
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {records?.map((eachRecord, i) => 
                                <TableRow key={i} className={`cursor-pointer ${
                                    selectedIds?.includes(eachRecord?.id)
                                      ? "[&>td]:!bg-blue-300"
                                      : ""
                                  }`} onClick={() => {toggleIds(eachRecord?.id)}}>
                                    <TableCell>{eachRecord?.date}</TableCell>
                                    <TableCell>{eachRecord?.location_name}</TableCell>
                                    <TableCell>{eachRecord?.tanker_no}</TableCell>
                                    <TableCell>{eachRecord?.quantity}</TableCell>
                                    <TableCell>{eachRecord?.amount}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    {isTryToSubmit && !selectedIds?.length && (
                        <p className='pt-2 text-red-600 text-[12px]'>{"Please Select Atleast One List"}</p>
                    )}
                </div>

                <div className={Style.modal_foot}>
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddInvoicePopup
